import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { msg } from 'api';

import PrimaryBarDropdown from 'lib/apps/header/components/PrimaryBarDropdown';
import NavigationMenuContent from 'lib/apps/topNavigation/containers/NavigationMenuContent';
import Icon from 'lib/widgets/Icon/Icon';
import UserAvatar from 'lib/apps/header/components/UserAvatar';

const MyAccount = ({ accountLinks, isLoggedIn, profilePictureUrl }) => {
  const [profilePictureExist, setProfilePictureExists] = useState(!!profilePictureUrl);

  if (!isLoggedIn) {
    return (
      <div className="hd-myAccount__authBtns">
        <Link
          to="/login"
          className="hd-myAccount__login"
        >
          Log in
        </Link>
        <Link
          to="/register"
          className="hd-myAccount__register"
        >
          Register
        </Link>
      </div>
    );
  }

  let profilePicture = <span className="hd-myAccount__profile hd-myAccount__profile--default" />;

  if (profilePictureExist) {
    profilePicture = (
      <span className="hd-myAccount__profile">
        <UserAvatar
          key="userAvatar"
          src={profilePictureUrl}
          alt="customer icon"
          onError={() => setProfilePictureExists(false)}
        />
      </span>
    );
  }

  if (accountLinks.length) {
    const buttonLabel = (
      <span className="hd-myAccount__label">
        { profilePicture }
        { msg.other.tab.myShop }
        <Icon
          name="chevron-down"
          className="hd-myAccount__chevronDown"
        />
      </span>
    );

    return (
      <>
        <PrimaryBarDropdown
          label={buttonLabel}
          className="hd-myAccount"
          linkClassName="hd-myAccount__link"
        >
          <NavigationMenuContent
            ignoreChildren
            sections={[{ children: accountLinks }]}
          />
        </PrimaryBarDropdown>
      </>
    );
  }

  return (
    <Link
      to="/settings"
      className="hd-myAccount__link"
    >
      { profilePicture }
      {msg.other.tab.myShop}
    </Link>
  );
};

MyAccount.propTypes = {
  accountLinks: PropTypes.array,
  isLoggedIn: PropTypes.bool.isRequired,
  profilePictureUrl: PropTypes.string,
};

MyAccount.defaultProps = {
  accountLinks: [],
};

export default MyAccount;
